import { ThemeProvider } from '@primer/react';
import { AuthProvider } from 'oidc-react';
import { useEffect, useMemo } from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import BaseStyles from './BaseStyles';
import { LazyPage } from './components-ui/loadable';
import LoaderPage from './components-ui/loader-page';
import { actions } from './state/actions';
import { eAccountReducerStatus } from './state/reducer-model/auth/IAuthReducer';
import { RootState } from './state/reducers/rootReducer';
import { CommonProvider } from './contexts/common';

const AuthorizedContent = LazyPage(import("./content/AuthorizedContent"))
const UnAuthorizedContent = LazyPage(import("./content/UnAuthorizedContent"))
const SigoutContent = LazyPage(import("./content/SigoutContent"))

function App() {
  const { status, user, isSignOuted } = useSelector((x: RootState) => x.auth)
  const { status: appConfigStatus, appConfig } = useSelector((x: RootState) => x.appConfig)
  const dispatch = useDispatch();

  const oidcConfig: any = useMemo(() => {
    if (!appConfig) {
      // debugger
    }
    return {
      authority: appConfig?.OIDC_AUTHORITY,
      clientId: appConfig?.OIDC_CLIENT_ID,
      redirectUri: appConfig?.OIDC_REDIRECT_URI,
      clientSecret: appConfig?.OIDC_CLIENT_SECRET,
      // userStore: new WebStorageStateStore({
      //     store: localStorage
      // })
    };
  }, [appConfig])
  useEffect(() => {
    dispatch(actions.auth.getUserStart());
  }, [])

  const dispath = useDispatch();
  useEffect(() => {
    dispath(actions.appConfig.loadStart())
  }, [])

  if (status === eAccountReducerStatus.is_getting_profile) {
    return <LoaderPage />
  }
  return (
    <Router>
      <ThemeProvider colorMode={"light"}>
        <BaseStyles>
          <CommonProvider>
            {isSignOuted === true &&
              <AuthProvider {...oidcConfig} >
                <SigoutContent />
              </AuthProvider>
            }
            {user && <AuthorizedContent />}
            {!user && <UnAuthorizedContent />}
          </CommonProvider>
        </BaseStyles>
      </ThemeProvider>
    </Router>
  );
}
export default App;
